import React from 'react';
import { AiOutlineGift } from 'react-icons/ai';
import { BiMessageSquareDetail } from 'react-icons/bi';
import { FiPackage, FiShoppingBag } from 'react-icons/fi';
import { MdOutlineLocalOffer } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleAvatarDropdown } from '../../state/uiSlice';
import AvatarDropdown from './AvatarDropdown';
import { getProfileAvatarUrl } from '../../utils/avatarUrl';

const ADMIN_AVATAR_FALLBACK = 'https://res.cloudinary.com/dzlopmfj8/image/upload/v1727275890/lsigqbplejpwkh0wxkkb.jpg';

const AdminHeader = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const avatarUrl = getProfileAvatarUrl(user, ADMIN_AVATAR_FALLBACK);

  const handleOpenAvatarMenu = () => {
    dispatch(toggleAvatarDropdown());
  };

  return (
    <div className="admin-header-container">
      <Link to="/" className="admin-header-logo-link" aria-label="MATRIX home">
        <span className="admin-header-site-logo" aria-hidden="true" />
      </Link>

      {/* Navigation Icons */}
      <div className="admin-header-nav">
        <Link to="/dashboard-coupons" className="admin-header-nav-item">
          <AiOutlineGift size={30} />
        </Link>
        <Link to="/dashboard-events" className="admin-header-nav-item">
          <MdOutlineLocalOffer size={30} />
        </Link>
        <Link to="/dashboard-products" className="admin-header-nav-item">
          <FiShoppingBag size={30} />
        </Link>
        <Link to="/dashboard-orders" className="admin-header-nav-item">
          <FiPackage size={30} />
        </Link>
        <Link to="/dashboard-messages" className="admin-header-nav-item">
          <BiMessageSquareDetail size={30} />
        </Link>

        <button
          type="button"
          className="admin-header-avatar-button"
          onClick={handleOpenAvatarMenu}
          aria-label="Open profile menu"
        >
          <img
            src={avatarUrl}
            alt="Admin Avatar"
            className="admin-header-avatar"
          />
        </button>
      </div>

      <AvatarDropdown />
    </div>
  );
};

export default AdminHeader;

